import { formFieldKeys } from '@messenger/consts'
import { handleString } from '@/utils/tinyMCE/caseDetails/handleString'
import { handleArray } from '@/utils/tinyMCE/caseDetails/handleArray'
import { handlePallbearersArray } from '@/utils/tinyMCE/caseDetails/handlePallbearersArray'
import { handleTextBlock } from '@/utils/tinyMCE/caseDetails/handleTextBlock'
import { handleNameOfDeceased } from '@/utils/tinyMCE/caseDetails/handleNameOfDeceased'
import { handleFirstLetter } from '@/utils/tinyMCE/caseDetails/handleFirstLetter'
import { handleAdditionalFamily } from '@/utils/tinyMCE/caseDetails/handleAdditionalFamily'
import { handleOrganizations } from '@/utils/tinyMCE/caseDetails/handleOrganizations'
import { formatMiddleInitial } from '@/utils/tinyMCE/formatMiddleInitial'

export const handleKeys = (
  editor,
  caseDetails,
  key,
  templates,
  dateFormat,
  selectedTheme,
  pageSetLocale,
) => {
  const obj = {
    name_of_deceased: () =>
      handleNameOfDeceased(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),

    // All other fields (Second)
    date_of_birth: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    place_of_birth: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    date_of_death: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    date_of_marriage: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    place_of_death: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    mother_of_deceased: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    father_of_deceased: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    spouse: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    website_obit_url: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    obituary: () =>
      handleTextBlock(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    family_appreciation_message: () =>
      handleTextBlock(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    order_of_service: () =>
      handleTextBlock(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    interment_place: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    interment_address: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    interment_lot: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    interment_section: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    interment_state: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    interment_postal_code: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    interment_block: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    interment_city: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    interment_date: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
        pageSetLocale,
      ),
    interment_county: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),
    interment_time: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        null,
        selectedTheme,
      ),

    // handle arrays
    children: () =>
      handleArray(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    siblings: () =>
      handleArray(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    songs: () =>
      handleArray(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    pallbearers: () =>
      handlePallbearersArray(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    // honorary_pallbearers delegates to handlePallbearersArray so legacy-only
    // honorary entries are still rendered when no regular pallbearers exist
    honorary_pallbearers: () =>
      handlePallbearersArray(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    clergy: () =>
      handleArray(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    // handle services
    // services: () =>
    //   handleServices(editor, caseDetails, key, templates, dateFormat),
    organizations: () =>
      handleOrganizations(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    // handle additional family
    additional_family: () =>
      handleAdditionalFamily(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        selectedTheme,
      ),
    // TODO: I have a refactor for this file to shorten it immensely, but I won't introduce it yet due to the size of changes it would cause
    // HANDLE FIRST LETTER
    first_letter_first_dec: () =>
      handleFirstLetter({
        editor,
        caseDetails,
        templates,
        dateFormat,
        selectedTheme,
        pageSetLocale,
        key: 'first_dec',
        label: 'First Letter of First Name',
      }),
    first_letter_middle_dec: () =>
      handleFirstLetter({
        editor,
        caseDetails,
        templates,
        dateFormat,
        selectedTheme,
        pageSetLocale,
        key: 'middle_dec',
        label: 'First Letter of Middle Name',
      }),
    first_letter_lastdec: () =>
      handleFirstLetter({
        editor,
        caseDetails,
        templates,
        dateFormat,
        selectedTheme,
        pageSetLocale,
        key: 'lastdec',
        label: 'First Letter of Last Name',
      }),
    // Individual name components (Last)
    prefix_dec: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        'Prefix Name',
        selectedTheme,
      ),
    first_dec: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        'First Name',
        selectedTheme,
      ),
    nick_name_dec: () => {
      const nickname =
        caseDetails[formFieldKeys.nickName] || caseDetails.nick_name_dec
      const formattedNickname = nickname ? `"${nickname}"` : nickname

      handleString(
        editor,
        { ...caseDetails, nick_name_dec: formattedNickname },
        key,
        templates,
        dateFormat,
        'Nickname',
        selectedTheme,
      )
    },
    middle_dec: () => {
      const middleName =
        caseDetails[formFieldKeys.middleName] || caseDetails.middle_dec
      const formattedMiddleName = middleName
        ? formatMiddleInitial(middleName)
        : middleName
      handleString(
        editor,
        { ...caseDetails, middle_dec: formattedMiddleName },
        key,
        templates,
        dateFormat,
        'Middle Name',
        selectedTheme,
      )
    },
    maiden_dec: () => {
      const maidenName =
        caseDetails[formFieldKeys.maidenName] || caseDetails.maiden_dec
      const formattedMaidenName = maidenName ? `(${maidenName})` : maidenName

      handleString(
        editor,
        { ...caseDetails, maiden_dec: formattedMaidenName },
        key,
        templates,
        dateFormat,
        'Maiden Name',
        selectedTheme,
      )
    },
    lastdec: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        'Last Name',
        selectedTheme,
      ),
    suffix_dec: () =>
      handleString(
        editor,
        caseDetails,
        key,
        templates,
        dateFormat,
        'Suffix Name',
        selectedTheme,
      ),
  }

  if (obj[key]) {
    obj[key]()
  }
}

export default handleKeys
